import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

export const LoginContext = createContext();

export const LoginProvider = ({ children }) => {
  const [loggedInUser, setLoggedInUser] = useState(null);

  const changeLoggedInUser = (user) => {
    console.log('Changing logged in user:', user);
    setLoggedInUser(user);
  };

  useEffect(() => {
    const gymtoken = localStorage.getItem('gymtoken');
    if (gymtoken) {
      getUser().then((user) => setLoggedInUser(user)).catch((error) => {
        console.error('Error fetching user:', error);
      });
    }
  }, [localStorage]);

  return (
    <LoginContext.Provider value={{ loggedInUser, changeLoggedInUser,getUser }}>
      {children}
    </LoginContext.Provider>
  );
};

export const useLogin = () => {
  const context = useContext(LoginContext);
  if (!context) {
    throw new Error('useLogin must be used within a LoginProvider');
  }
  return context;
};

export const getUser = async () => {
  try {
    const response = await axios.get('https://klimkaara-backend-pgnq.onrender.com/user/getuser', {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('gymtoken'),
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching user:', error);
    return null;
  }
};

